import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { AppRoutesUI } from "../config/appRoutes";
import { useAppSelector } from "../core/redux";
import { AuthSliceState } from "../core/redux/slices/authSlice";

export const RedirectUnauthorized = (props: PropsWithChildren<{}>) => {
  const { isLoggedIn } = useAppSelector(
    (state: { auth: AuthSliceState }) => state.auth
  );

  if (isLoggedIn) return <>{props.children}</>;
  else return <Navigate to={AppRoutesUI.Auth.Login.Path()} replace />;
};

export const RedirectAuthorized = (props: PropsWithChildren<{}>) => {
  const { isLoggedIn } = useAppSelector(
    (state: { auth: AuthSliceState }) => state.auth
  );

  if (!isLoggedIn) return <>{props.children}</>;
  else return <Navigate to={AppRoutesUI.Home.Path()} replace />;
};
